<template>
  <div id="page" :class="{fixed: showScreenDialog}">
    <div class="app-content" :class="{show: show}">
      <div class="swiper-card swiper-container" :class="{'have-card': gateways.length}">
        <div class="swiper-wrapper">
          <div class="swiper-slide oilcard-item" :class="{'first-child': swiperIsZero, gjdw: card.type === 1, gjsw: card.type === 2}" v-for="(card, key) in gateways" :key="key">
            <div class="wrap">
              <div class="name">{{card.is_nf ? '南方电网' : '国家电网'}}</div>
              <div class="text">缴费户</div>
              <div class="card-name">{{card.province}} - {{card.name}}</div>
              <div class="number">{{card._number}}</div>
              <div class="btns">
                <i class="icon iconfont icon-gengduo" @click="() => {showPopover = !showPopover}"></i>
                <i class="icon iconfont icon-gengduosel" @click="goBandCard"></i>
              </div>
              <transition name="fade">
                <div v-if="showPopover" class="popover">
                  <i class="icon iconfont icon-shanchu"></i>
                  <span class="text" @click="() => onDelOilCard(card.id)">删除缴费户</span>
                </div>
              </transition>
            </div>
          </div>
          <div class="swiper-slide bind-card">
            <div class="wrap">
              <div class="title">新增缴费户</div>
              <div class="flex">
                <div class="item" @click="onBindCard">
                  <div class="img"><img src="@/assets/images/gjdw.png" alt=""></div>
                  <div class="name"><span>新增电费户</span><i class="icon iconfont icon-you"></i></div>
                </div>
                <div class="item" :class="{disabled: true}">
                  <div class="img"><img src="@/assets/images/sf.png" alt=""></div>
                  <div class="name"><span>新增水费户</span><i class="icon iconfont icon-you"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="recharge-type">
        <div class="desc" v-if="!serveEnable">{{stopServeMsg}}</div>
        <template v-else>
          <div class="title">选择金额</div>
          <div class="tags" v-if="show">
            <template v-if="gatewayCur && gatewayCur.id && gatewayCur.is_nf">
              <div class="item" v-for="(item, key) in specs" :key="key" v-if="item.g_name === '南方电网'" @click="() => specCur = item" :class="{cur: specCur && specCur.spec_id === item.spec_id}">
                <div class="price1">{{item.official_price}} 元</div>
                <div class="price2"><span class="text">售价</span><span class="num">{{item.retail_price}}</span><span class="text">元</span></div>
              </div>
            </template>
            <template v-else>
              <div class="item" v-for="(item, key) in specs" :key="key" v-if="item.g_name === '国家电网'" @click="() => specCur = item" :class="{cur: specCur && specCur.spec_id === item.spec_id}">
                <div class="price1">{{item.official_price}} 元</div>
                <div class="price2"><span class="text">售价</span><span class="num">{{item.retail_price}}</span><span class="text">元</span></div>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div class="agreement-check">
        <i class="icon iconfont icon-gouxuan" :class="{checked: docChecked}" @click="() => { docChecked = !docChecked }"></i>
        <span class="text">我已阅读并同意</span>
        <span class="doc" @click="onDoc">《服务协议》</span>
      </div>
      <div class="recharge-desc">
        <div class="tips-title"><i class="icon iconfont icon-tishi"></i><span>温馨提示</span></div>
        <ul class="list">
          <li v-for="(item, key) in pageReminder" :key="key" v-html="item"></li>
        </ul>
      </div>
      <div class="cashier">
        <div class="issue" @click="onIssue">
          <span class="icon"><i class="iconfont icon-runtongyiyaoyihuifu_wenti-22"></i></span>
          <span class="text">咨询客服</span>
        </div>
        <div class="order" @click="onOrders">
          <span class="icon"><i class="iconfont icon-dingdan"></i></span>
          <span class="text">订单查询</span>
        </div>
        <div class="amount" v-if="show">
          <template v-if="!specCur">
            <div class="price"><span class="unit">¥</span><span class="num">0</span></div>
            <div class="text">未选择缴费户</div>
          </template>
          <template v-else>
            <div class="price red"><span class="unit">¥</span><span class="num">{{ specCur.retail_price }}</span></div>
            <div class="text">{{ specCur.official_price }}元面额</div>
          </template>
        </div>
        <button class="btn" v-if="show" @click="onVerify">立即充值</button>
      </div>
      <transition name="fade">
        <div v-if="showDialogPay" class="confirm-pay">
          <div class="weui-mask" @click="onCancel2"></div>
          <div class="weui-half-screen-dialog" :class="{'weui-half-screen-dialog_show': showDialogPay}">
            <div class="weui-half-screen-dialog__hd">
              <div class="weui-half-screen-dialog__hd__main">
                <strong class="weui-half-screen-dialog__title">支付方式</strong>
              </div>
              <div class="weui-half-screen-dialog__hd__side">
                <button class="weui-icon-btn" @click="onCancel2">关闭<i class="weui-icon-close-thin"></i></button>
              </div>
            </div>
            <div class="weui-half-screen-dialog__bd">
              <div class="pay-list">
                <div class="item" @click="() => onConfirm('wxpay')" :class="{disabled: !isWxPay}">
                  <span class="icon"><img src="@/assets/images/wxpay.png" alt=""></span>
                  <span class="text">微信支付</span>
                </div>
                <div class="item" @click="() => onConfirm('alipay')" :class="{disabled: !isAliPay}">
                  <span class="icon"><img src="@/assets/images/alipay.png" alt=""></span>
                  <span class="text">支付宝</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast weui-toast_text">
            <p class="weui-toast__content">{{toastMsg}}</p>
          </div>
        </div>
      </transition>
      <div v-if="showDialogConfirm" class="cashier-dialog">
        <div class="weui-mask"></div>
        <div class="weui-half-screen-dialog" :class="{'weui-half-screen-dialog_show': showScreenDialog}">
          <div class="weui-half-screen-dialog__hd">
            <div class="weui-half-screen-dialog__hd__main">
              <strong class="weui-half-screen-dialog__title">¥{{specCur.retail_price}}</strong>
            </div>
            <div class="weui-half-screen-dialog__hd__side">
              <button class="weui-icon-btn" @click="onCancel"><i class="weui-icon-close-thin"></i></button>
            </div>
          </div>
          <div class="weui-half-screen-dialog__bd">
            <ul class="bill-info">
              <li><span class="label">订单信息</span><span class="text">电费充值{{specCur.official_price}}元</span></li>
              <li><span class="label">充值户号</span><span class="text b">{{gatewayCur._number}}</span></li>
              <li><span class="label">归属省份</span><span class="text b">{{gatewayCur.province}}</span></li>
              <li><span class="label">支付方式</span><span class="text">{{payType === 'alipay' ? '支付宝' : '微信'}}</span></li>
            </ul>
            <div class="desc">
              <h5>充值须知</h5>
              <ul>
                <li v-for="(item, key) in pageReminder" :key="key" v-html="item"></li>
              </ul>
            </div>
            <div class="confirm-check weui-cells weui-cells_checkbox">
              <label class="weui-cell weui-cell_active weui-check__label">
                <div class="weui-cell__hd">
                  <input type="checkbox" v-model="docChecked" class="weui-check">
                  <i class="weui-icon-checked"></i>
                </div>
                <div class="weui-cell__bd">我已阅读并了解【充值须知】，并已确认充值户号、省份</div>
              </label>
            </div>
          </div>
          <div class="weui-half-screen-dialog__ft">
            <a href="javascript:" class="weui-btn weui-btn_primary" @click="onSubmit">立即支付</a>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="showLoading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
                <span class="weui-primary-loading weui-icon_toast">
                  <span class="weui-primary-loading__dot"></span>
                </span>
          <p class="weui-toast__content">加载中...</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="less" scoped>
  #page {
    min-height: 100vh;
    background-color: #fff;
  }
  #page.fixed {
    height: 100vh;
    overflow: hidden;
  }
  .app-content {
    opacity: 0;
    transition: opacity 0.2s ease;
    background-color: #fff;
  }
  .app-content.show {
    opacity: 1;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: opacity 0.2s;
  }
  .swiper-card.swiper-container {
    perspective: 1200px;
    margin: 0 -0.85rem;
    padding-top: 0.85rem;
    .swiper-wrapper {
      position: static;
    }
    .swiper-slide {
      width: 90%;
      transform-style: preserve-3d
    }
  }
  .swiper-live {
    flex: 1;
    display: flex;
    margin: 0;
    height: 1.75rem;
  }
  .app-content {
    padding: 0 0.85rem;
    color: #333;
    .oil-tips {
      height: 1.75rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 4px;
      .location {
        b {
          padding: 0 2px;
        }
      }
    }
    .live {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-weight: 600;
      .label {
        color: #b3b3b3;
        padding: 0 0.25rem;
        &.last {
          margin-left: 0.3rem;
        }
      }
    }
    .oilcard-item {
      &.first-child {
        .wrap {
          margin: 0 4% 0.5rem 0;
        }
      }
      .wrap {
        position: relative;
        display: flex;
        flex-direction: column;
        height: 138px;
        border: 1px #eaeaea solid;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .05);
        margin: 0 2% 12px 2%;
      }
      .wrap {
        background: url("../assets/images/gjdw_bann.png") no-repeat 0 0;
        background-size: cover;
      }
      .name, .text {
        padding-left: 60px;
        color: #fff;
      }
      .name {
        padding-top: 18px;
        font-size: 15px;
        font-weight: 500;
      }
      .text {
        font-size: 13px;
      }
      .card-name {
        color: #fff;
        font-size: 15px;
        padding-top: 18px;
        padding-left: 20px;
        font-weight: 500;
      }
      .number {
        font-family: 'DIN1451';
        color: #fff;
        font-size: 24px;
        padding-left: 18px;
        line-height: 1.2;
      }
      .btns {
        position: absolute;
        top: 14px;
        right: 14px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .icon {
          color: #fff;
          font-size: 22px;
          margin-left: 5px;
        }
      }
      .popover {
        position: absolute;
        top: 11px;
        right: 72px;
        width: 120px;
        height: 36px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        background-color: #465257;
        .icon {
          padding-right: 6px;
          padding-bottom: 2px;
        }
        .text {
          padding-left: 0;
          font-size: 15px;
          font-weight: 500;
        }
        &:before {
          position: absolute;
          top: 50%;
          right: -5px;
          width: 10px;
          height: 10px;
          background-color: #465257;
          content: '';
          transform: translateY(-50%) rotate(-45deg);
        }
      }
    }
    .swiper-card.have-card .bind-card .wrap {
      margin: 0 2% 12px 2%;
    }
    .bind-card {
      .wrap {
        height: 138px;
        border: 1px #eaeaea solid;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .05);
      }
      .title {
        height: 42px;
        line-height: 44px;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        overflow: hidden;
      }
      .flex {
        padding-top: 5px;
        overflow: hidden;
        .item {
          position: relative;
          display: flex;
          float: left;
          width: 50%;
          flex-direction: column;
          align-items: center;
          &.disabled .img {
            filter: grayscale(100%);
          }
          .img {
            height: 54px;
          }
          .name {
            padding-top: 4px;
            font-size: 15px;
            font-weight: 600;
            color: #588aff;
            display: flex;
            align-items: center;
          }
        }
      }
    }
    .recharge-type {
      .title {
        height: 2.2rem;
        line-height: 2.2rem;
        font-size: 17px;
        font-weight: 500;
        color: #333;
      }
      .desc {
        font-size: 13px;
        padding: 6px 12px 6px 6px;
        line-height: 24px;
        background-color: #fff1b8;
        border-radius: 4px;
      }
      .app-content .layer-3 .tags {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        overflow: hidden;
      }
      .tags {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        overflow: hidden;
      }
      .tags .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 48%;
        height: 2.75rem;
        background-color: #fff;
        border-radius: 6px;
        margin-bottom: 4%;
        border: 2px #e8e8e8 solid;
        &.cur {
          border: 2px #588aff solid;
          .price1 {
            color: #588aff;
          }
          .price2 {
            .text, .unit, .num {
              color: #588aff;
            }
          }
        }
        &:nth-child(2n+0) {
          margin-left: 4%;
        }
        .price1 {
          font-size: 18px;
          color: #000;
          font-weight: 500;
          line-height: 1.3;
          font-family: 'DIN1451';
        }
        .price2 {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          .text {
            font-size: 14px;
            color: #000;
          }
          .unit {
            font-size: 13px;
            color: #000;
            font-weight: bold;
            padding-bottom: 1px;
            padding-right: 2px;
          }
          .num {
            font-size: 17px;
            color: #000;
            font-weight: 500;
            padding: 0 3px;
            font-family: 'DIN1451' !important;
          }
        }
      }
    }
    .recharge-desc {
      padding-bottom: 3rem;
      .tips-title {
        margin-top: 0.5rem;
        background-image: linear-gradient(to right, #91d5ff , #588aff);
        display: inline-block;
        font-size: 14px;
        color: #fff;
        font-weight: 200;
        padding: 2px 6px;
        border-radius: 8px 0 8px 0;
      }
      .list {
        list-style: none;
        margin-top: 0.5rem;
        margin-bottom: 0.25rem;
        li {
          font-size: 14px;
          line-height: 1.6;
          padding-bottom: 6px;
        }
        li b {
          color: #588aff;
        }
      }
    }
    .agreement-check {
      margin: 0.5rem 0;
      padding-top: 0.75rem;
      border-top: 1px solid #efefef;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      .icon {
        margin-right: 8px;
        color: #e7e7e7;
        font-size: 20px;
        &.checked {
          color: #333;
        }
      }
      .doc {
        color: #588aff;
      }
    }
    .cashier {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 3rem;
      display: flex;
      background-color: #fff;
      flex-direction: row;
      align-items: center;
      border-top: 1px solid #efefef;
      .issue, .order {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 1;
        .text {
          padding-top: 4px;
          font-weight: 400;
        }
      }
      .icon {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 1.25rem;
      }
      .issue {
        margin-left: 2.25%;
      }
      .order {
        margin-left: -1.5%;
      }
      .issue .icon .iconfont {
        font-size: 28px;
      }
      .order .icon .iconfont {
        font-size: 24px;
      }
      .amount {
        position: relative;
        flex: 1;
        padding-left: 0.5rem;
        .price {
          display: flex;
          flex-direction: row;
          align-items: center;
          color: #ababab;
          font-weight: 500;
          line-height: 1.2;
          &.red {
            color: #f75f6e;
          }
          .unit {
            font-size: 18px;
            font-weight: bold;
            margin-right: 3px;
            padding-top: 6px;
          }
          .num {
            font-size: 28px;
            font-family: 'DIN1451' !important;
          }
        }
        .text {
          color: #ababab;
          font-weight: 500;
          font-size: 13px;
        }
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 1px;
          content: '';
          background-color: #eee;
        }
      }
      .btn {
        border: 0;
        background: #588aff;
        width: 4.8rem;
        height: 1.875rem;
        margin-right: 0.55rem;
        border-radius: 1.875rem;
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        outline: none;
      }
    }
    .translate-enter {
      transform: translateY(100%);
    }
    .translate-active {
      transition: transform .3s;
    }
    .weui-half-screen-dialog {
      max-height: 95%;
      transform: translateY(100%);
      transition: transform .3s;
      &.weui-half-screen-dialog_show {
        transform: translateY(0);
      }
    }
    .cashier-dialog {
      .weui-half-screen-dialog__title {
        font-size: 26px;
        font-weight: 500;
        text-align: center;
      }
      .weui-half-screen-dialog__bd {
        padding-bottom: 16px;
      }
      .weui-half-screen-dialog__ft {
        padding-bottom: 32px;
        .weui-btn_primary {
          width: 100%;
          background-color: #588aff;
          color: #fff;
          font-weight: normal;
          border-radius: 20px;
        }
      }
      .bill-info {
        li {
          display: flex;
          justify-content: space-between;
          padding: 4px 0;
          .label {
            color: #999;
          }
          .text {
            color: #333;
            &.b {
              color: #d06926;
            }
          }
        }
      }
      .desc {
        max-height: 240px;
        overflow-y: auto;
        color: #333;
        h5 {
          font-size: 15px;
          padding-bottom: 5px;
          padding-top: 16px;
        }
        ul {
          list-style: none;
          li {
            font-size: 13px;
            text-align: left;
            color: #444;
            padding-bottom: 2px;
            b {
              color: red;
            }
          }
        }
      }
      .confirm-check {
        display: flex;
        flex-direction: row;
        align-content: center;
        padding-top: 12px;
        margin-top: 12px;
        &:after{
          display: none;
        }
        .weui-cell {
          padding: 0;
        }
        .weui-check__label {
          background-color: #fff;
        }
        .weui-cell__hd {
          padding-right: 8px;
        }
        .weui-cell__bd {
          font-size: 13px;
          text-align: left;
          color: #444;
        }
      }
    }
    .confirm-pay {
      position: relative;
      z-index: 1001;
    }
    .confirm-pay .weui-half-screen-dialog__hd__main+.weui-half-screen-dialog__hd__side {
      right: 16px;
    }
    .confirm-pay .weui-half-screen-dialog {
      border-top-left-radius: 24px;
      border-top-right-radius: 24px;
      padding: 0;
    }
    .confirm-pay .weui-half-screen-dialog__hd {
      height: 6.5em;
      border-bottom: 1px #efefef solid;
    }
    .confirm-pay .weui-half-screen-dialog__bd {
      padding-bottom: 30px;
    }
    .confirm-pay .weui-half-screen-dialog__title {
      text-align: center;
      font-size: 17px;

    }
    .confirm-pay .pay-list {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-top: 16px;
      justify-content: space-around;
    }
    .confirm-pay .pay-list .item {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .confirm-pay .pay-list .item.disabled img {
      filter: grayscale(100%);
    }
    .confirm-pay .pay-list .item .icon {
      height: 58px;
      display: flex;
      align-items: center;
    }
    .confirm-pay .pay-list .item .icon img{
      width: 44px;
      color: #555;
      font-size: 16px;
    }
    .confirm-dialog {
      position: relative;
      z-index: 1001;
      .weui-dialog__btn_primary {
        color: #588aff;
      }
      .weui-dialog__title {
        font-size: 18px;
      }
      .weui-dialog__bd {
        text-align: left;
        p {
          width: 270px;
          margin: 0 auto;
          padding-bottom: 2px;
          span {
            color: #f75f6e;
          }
        }
      }
    }
  }
  @media screen and (max-width: 320px) {
    .app-content .cashier .issue,
    .app-content .cashier .order {
      font-size: 12px;
    }
    .app-content .cashier .btn button {
      font-size: 16px;
    }
    .app-content .layer-4 .list li {
      font-size: 13px;
    }
    .app-content .confirm-dialog {
      .weui-dialog__title {
        font-size: 16px;
      }
      .weui-dialog__bd p {
        width: auto;
        font-size: 14px;
      }
    }
    .app-content .recharge-type .tags .item {
      .price1 {
        font-size: 16px;
      }
      .price2 {
        .text {
          font-size: 13px;
        }
        .num {
          font-size: 15px;
          padding-bottom: 2px;
        }
      }
    }
    .app-content .cashier .amount .text {
      font-size: 12px;
    }
    .app-content .cashier .btn {
      font-size: 15px;
      width: 88px;
    }
  }
</style>

<script>
import request from "../utils/request";
import moment from 'moment';
export default {
  name: 'home',
  data() {
    return {
      show: false,
      showLoading: false,
      showToast: false,
      showDialogConfirm: false,
      showDialogPay: false,
      showPopover: false,
      showScreenDialog: false,
      pageReminder: [],
      isExpiryAtOut: false,
      docChecked: true,
      toastMsg: '',
      disabled: false,
      payType: '',
      rechargeType: 1,
      specs: [],
      gateways: [],
      gatewayCur: {},
      specCur: null,
      checkUserInfo: false,
      checkAppKey: false,
      isWxPay: false,
      isAliPay: false,
      swiper: null,
      swiperIsZero: true,
      memberId: null,
      userInfo: {},
      appEnv: {
        prod: true,
        appId: '',
        appKey: '',
        platformId: null,
      },
      serveEnable: true,
      stopServeMsg: null,
    };
  },
  computed: {
  },
  created() {
    this.appEnv.prod = process.env.VUE_APP_RELEASE === 'prod';
    if (!this.appEnv.prod) {
      this.appEnv.appId = 'CC202104110012172897';
      this.appEnv.appKey = 'EDF0763043A073BC';
      this.appEnv.platformId = 13;
      this.userInfo = {
        id: 122551,
        invite_code: "120897",
        avatar: "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLD9jWrnw4j9YFHIKiaE71Pka0Bnz2t8vjcQGax1YibKPLehSjhfqd0uibFziaC1unYb5O80OUI7VDGsQ/132",
        nickname: "文贤",
      };
      new VConsole();
    }
  },
  mounted() {
    const appId = this.$route.query.appid || '';
    const platformId = this.$route.query.platformid || '';
    const uid = this.$route.query.uid || 0;

    if (appId) this.appEnv.appId = appId;
    if (platformId) this.appEnv.platformId = parseInt(platformId, 10) || 0;
    if (uid) this.userInfo.id = parseInt(uid, 10);
    if (!this.appEnv.appId) {
      this.showLoading = false;
      this.show = true;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }


    const h5Userinfo = getH5UserInfo();
    if (h5Userinfo) {
      new Promise(async () => {
        await h5Userinfo.then((resp) => {
          this.checkUserInfo = true;
          this.userInfo = JSON.parse(resp);
        }).catch((err) => {
          if (typeof err === 'object') {
            this.showLoading = false;
            this.show = true;
            this.toast('未能获取到用户信息请联系客服: ' + JSON.parse(err));
          } else if (typeof  err === 'string') {
            this.toast('未能获取到用户信息请联系客服: ' + err);
          }
        });
        await checkAppInfo().then(version => {
          this.showLoading = true;
          this.getTenantCfg(version).then(async () => {
            this.getAppConf().catch(err => {})
            await this.getSpecs().then().catch(err => {});
            await this.getMemberInfo().then().catch(err => {});
            this.show = true;
            this.initSwiper();
            setTimeout(() => {
              this.showLoading = false;
            }, 150);
          }).catch((err) => {
            this.show = true;
            setTimeout(() => {
              this.showLoading = false;
            }, 150);
          });
        });
      })
    } else {
      if (!this.appEnv.prod) {
        this.showLoading = true;
        this.getTenantCfg(this.appEnv.appKey).then(async () => {
          this.getAppConf().catch(err => {})
          await this.getSpecs().then().catch(err => {});
          await this.getMemberInfo().then().catch(err => {});
          this.show = true;
          this.initSwiper();
          setTimeout(() => {
            this.showLoading = false;
          }, 150);
        }).catch((err) => {
          this.show = true;
          setTimeout(() => {
            this.showLoading = false;
          }, 150);
        });
      } else {
        this.showLoading = false;
        this.show = true;
        this.toast('未能获取到用户信息请联系客服');
      }
    }
  },
  methods: {
    moment,
    initSwiper() {
      this.swiper = new Swiper(".swiper-card", {
        slidesPerView: "auto",
        centeredSlides: true,
        watchSlidesProgress: true,
        paginationClickable: true,
        onProgress: (a) => {
          let b, c, d, scale, es;
          for (b = 0; b < a.slides.length; b++) c = a.slides[b], d = c.progress, scale = 1 - Math.min(Math.abs(.2 * d), 1), es = c.style; // es.margin = '0 4% 0.5rem 0'; // es.opacity = 1 - Math.min(Math.abs(d / 2), 1); // es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = "translate3d(0px,0," + -Math.abs(150 * d) + "px)";
        },
        onSetTransition: (a, b) => {
          let es;
          for (let c = 0; c < a.slides.length; c++) es = a.slides[c].style, es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = b + "ms";
        },
        onSlideChangeStart: (swiper) => {
          this.showPopover = false;
          this.specCur = null;
          this.swiperIsZero = !swiper.activeIndex;
          if (this.gateways.length) {
            const gateway = this.gateways[swiper.activeIndex];
            if (gateway) {
              this.rechargeType = gateway.type;
              this.gatewayCur = gateway;
            } else {
              this.gatewayCur = {};
            }
          }
        }
      });
    },
    initDayOilSwiper() {
      new Swiper('.swiper-live', {
        direction: 'vertical',
        autoplay: 2500,
        speed: 600,
        loop: true,
      });
    },
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.checkUserInfo;
    },
    toast(v, write = true) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
      if (write) {
        request({
          url: `/open/api/analysis/log`,
          method: 'POST',
          data: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, nickname: this.userInfo.nickname, msg: v},
        }).then().catch(err => {})
      }
    },
    getTenantCfg(version) {
      const newRequest = request({
        url: `/open/api/account/config`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: version }
      });
      newRequest.then((resp) => {
        const {expiry_at, appkey, wxpay, alipay, page_reminder} = resp;
        this.appEnv.appKey = version;
        this.isWxPay = wxpay;
        this.isAliPay = alipay;
        this.checkAppKey = appkey === version;
        this.pageReminder = page_reminder.split(/[\n\r]/g);
        const expiryAt = moment(expiry_at, 'YYYY-MM-DD HH:mm');
        const nowAt = moment(new Date());
        if (nowAt.isAfter(expiryAt)) {
          this.isExpiryAtOut = true;
          this.toast('服务存在异常，错误码：10001');
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    getAppConf() {
      return new Promise(async (resolve, reject) => {
        let globalConfig = []
        let accountConfig = []
        await request({
          url: `/open/api/sys/conf`,
          method: 'GET',
        }).then((resp) => {
          globalConfig = resp.list || []
        }).catch(err => {
          reject(err)
        })

        await request({
          url: `/open/api/account/conf`,
          method: 'GET',
          params: {platformId: this.appEnv.platformId}
        }).then((resp) => {
          accountConfig = resp.list || []
          let electricityFeesServiceStartDate, electricityFeesServiceEndDate, electricityFeesStopServiceText = null
          let electricityFeesEnable = true
          for (const t of accountConfig) {
            const {field, value} = t
            if (field === 'ElectricityFeesEnable') {
              electricityFeesEnable = !!+value
            }
            if (field === 'ElectricityFeesServiceStartDate') {
              electricityFeesServiceStartDate = +value
            }
            if (field === 'ElectricityFeesServiceEndDate') {
              electricityFeesServiceEndDate = +value
            }
            if (field === 'ElectricityFeesStopServiceText') {
              electricityFeesStopServiceText = value
            }
          }
          for (const t of globalConfig) {
            const {field, value} = t
            if (field === 'ElectricityEnable') {
              this.serveEnable = !!+value
            }
          }
          if (this.serveEnable) {
            this.serveEnable = electricityFeesEnable
          }
          this.stopServeMsg = electricityFeesStopServiceText
          if (electricityFeesEnable && electricityFeesServiceStartDate && electricityFeesServiceEndDate) {
            const nowDate = this.moment().date()
            if (nowDate < electricityFeesServiceStartDate || nowDate > electricityFeesServiceEndDate) {
              this.serveEnable = false
            }
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    getSpecs() {
      const newRequest = request({
        url: `/open/api/goods/specs/electricity`,
        method: 'GET',
        params: {appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId}
      });
      newRequest.then((resp) => {
        this.specs = (resp || []).filter(t => t.retail_price && t.enable).sort((a, b) => {
          return a.official_price - b.official_price;
        });
        if (!this.specs.length) {
          this.serveEnable = false
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    getMemberInfo() {
      const newRequest = request({
        url: `/open/api/member/link`,
        method: 'POST',
        data: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: this.appEnv.appKey, uid: this.userInfo.id, nickname: this.userInfo.nickname, avatar: this.userInfo.avatar, invite_code: this.userInfo.invite_code}
      });
      newRequest.then((resp) => {
        this.gateways = resp.gateways || [];
        this.memberId = resp.id;
        for (let i = 0; i < this.gateways.length; i++) {
          const gateway = this.gateways[i];
          gateway._number = gateway.number.replace(/\s/g,'').replace(/\D/g,'').replace(/(\d{4})(?=\d)/g,"$1 ");
          if (i === 0) {
            this.rechargeType = gateway.type;
            this.gatewayCur = gateway;
          }
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    goBandCard() {
      const slides = document.querySelectorAll('.swiper-card .swiper-wrapper .swiper-slide');
      this.swiper.slideTo(slides.length - 1);
    },
    onDelOilCard(id) {
      this.showPopover = false;
      this.showLoading = true;
      const newRequest = request({
        url: `/open/api/member/gateway/${id}?uid=${this.memberId}`,
        method: 'DELETE',
      });
      newRequest.then(() => {
        this.getMemberInfo().then(() => {
          this.showLoading = false;
        })
      }).catch((error) => {
        this.showLoading = false;
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    onDoc() {
      this.$router.push({
        path: '/doc',
        query: {appid: this.appEnv.appId, platformid: this.appEnv.platformId, appkey: this.appEnv.appKey},
      });
    },
    onBindCard() {
      this.$router.push({
        path: '/bind-card',
        query: {uid: this.memberId},
      });
    },
    onIssue() {
      if (this.appEnv.appKey === '44D36A9F643D169F') {
        window.location.href = 'https://www.taowuyou.com/kefu/weixin/';
      } else if (this.appEnv.appKey === '849B8FB49463D4D9') {
        window.location.href = 'https://work.weixin.qq.com/kfid/kfc9ad9e86ab24762ad';
      } else {
        openLinkByAlias('customerService');
      }
    },
    onOrders() {
      if (!this.userInfo.id) {
        this.toast('未能获取到用户信息请联系客服: ');
      } else {
        this.$router.push({
          path: '/orders',
          query: {appid: this.appEnv.appId, platformid: this.appEnv.platformId || 0, appkey: this.appEnv.appKey, uid: this.userInfo.id, invite_code: this.userInfo.invite_code},
        });
      }
    },
    onCancel() {
      this.showScreenDialog = false;
      setTimeout(() => {
        this.showDialogConfirm = false;
      }, 300)
    },
    onCancel2() {
      this.showScreenDialog = false;
      setTimeout(() => {
        this.showDialogPay = false;
      }, 300)
    },
    onVerify() {
      // this.toast('电费充值正在系统维护中，预计9月17日恢复正常');
      // return;
      if (this.isExpiryAtOut) {
        this.toast('服务存在异常，错误码：10001');
        return;
      }
      if (this.appEnv.prod && !this.isHuaJuanY()) {
        this.toast('当前请移至App平台');
        return;
      }
      if (!this.checkAppKey) {
        this.toast('商户关联平台不一致请联系客服: ' + this.appEnv.appKey);
        return;
      }
      if (!this.specCur) {
        this.toast('请选择充值面额', false);
        return;
      }
      if (!this.gatewayCur.id) {
        if (this.gateways.length) {
          this.toast('请先滑动选择缴费户', false);
        } else {
          this.toast('请先绑定缴费户', false);
        }
        return;
      }
      if (this.gatewayCur.province === '天津' && this.specCur.official_price > 100) {
        this.toast('天津地区日限额100元，请重新选择', false);
        return;
      }
      if (!this.docChecked) {
        this.toast('请阅读并同意《服务协议》', false)
        return;
      }
      this.showDialogPay = true;
      setTimeout(() => {
        this.showScreenDialog = true;
      }, 0)
    },
    onConfirm(v) {
      // this.toast('电费充值正在系统维护中，预计9月17日恢复正常');
      // return;
      if (v === 'wxpay' && !this.isWxPay) {
        this.toast('商户暂不支持微信支付', false);
        return;
      } else if (v === 'alipay' && !this.isAliPay) {
        this.toast('商户暂不支持支付宝支付', false);
        return;
      }
      this.payType = v;
      this.showDialogPay = false;
      this.showScreenDialog = false;
      this.showDialogConfirm = true;
      setTimeout(() => {
        this.showScreenDialog = true;
      }, 0)
    },
    onSubmit() {
      this.disabled = true;
      this.showLoading = true;
      this.showDialogConfirm = false;
      request({
        url: `/open/api/recharge/pay`,
        method: 'POST',
        data: {type: this.payType, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, goods_id: this.specCur.g_id, specs_id: this.specCur.spec_id, uid: this.userInfo.id, invite_code: this.userInfo.invite_code, nickname: this.userInfo.nickname, avatar: this.userInfo.avatar, card_id: this.gatewayCur.id, phone: null},
      }).then((resp) => {
        this.disabled = false;
        setTimeout(() => {
          this.showLoading = false;
          this.showScreenDialog = false;
          this.showDialogConfirm = false;
        }, 1000);
        window.location.href = resp.url;
      }).catch((error) => {
        this.disabled = false;
        this.showLoading = false;
        this.showScreenDialog = false;
        setTimeout(() => {
          this.showDialogConfirm = false;
          if (error.response && error.response.data) {
            this.toast(error.response.data.msg);
          }
        }, 250)
      });
    }
  }
}
</script>
